import React from 'react'

import InputContainer from './InputContainer.js'
import TextInput from '../ncss/TextInput.js'

export default ({ label, input, title, meta, ...props }) => (
  <InputContainer label={label} meta={meta} title={title}>
    <TextInput {...input} {...props} />
  </InputContainer>
)



// WEBPACK FOOTER //
// ./client/src/components/forms/TextInput.js